<template>
  <div>
    <a-row type="flex">
      <a-col flex="280px">
        <div class="flex-between" style="margin-bottom: 10px">
          <span class="title-2">{{ title }}</span>
          <a-button type="primary" @click="createLeague">{{ btnText }}</a-button>
        </div>
        <div class="collapse">
          <!-- 分类折叠框-->
          <a-collapse v-if="isShowSort" v-model="activeKey">
            <a-collapse-panel
              v-for="item in collapseList"
              :key="item.key"
              :header="item.header"
              style="background-color: #eff2f5; cursor: pointer"
            >
              <div
                v-for="child in item.children"
                :key="child.key"
                :class="{ 'collapse-item': true, active: activePaneObj.key === child.key }"
                @click="selectItem(child)"
              >
                <span style="margin-right: 20px">{{ child.header }}</span>
                <a-icon type="edit" :style="{ fontSize: '16px' }" @click.stop="editItem(child)" />
              </div>
            </a-collapse-panel>
          </a-collapse>
          <!--列表展示-->
          <template v-else>
            <template v-for="item in collapseList">
              <div
                v-for="child in item.children"
                :key="child.key"
                :class="{ 'collapse-item': true, active: activePaneObj.key === child.key }"
                @click="selectItem(child)"
              >
                <span style="margin-right: 20px">{{ child.header }}</span>
                <a-icon type="edit" :style="{ fontSize: '16px' }" @click.stop="editItem(child)" />
              </div>
            </template>
          </template>
        </div>
      </a-col>
      <a-col flex="2px">
        <a-divider type="vertical" style="height: 700px" />
      </a-col>
      <a-col flex="auto">
        <div style="margin-left: 15px" v-html="activePaneObj.content"></div>
      </a-col>
    </a-row>
    <CreateSubjectModal
      :sortDictCode="sortDictCode"
      :isShowSort="isShowSort"
      :actionType="actionType"
      ref="createSubjectModalRef"
      @refreshData="getTeacherGrowthList"
      :actionUrl="currActionUrl"
    />
  </div>
</template>

<script>
import CreateSubjectModal from '@/comUi/CreateSubjectModal.vue'
import { getAction } from '@api/manage'
import { sortFlatToTree } from '@/utils/util'

export default {
  name: 'CollapseResource',
  components: {
    CreateSubjectModal,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '创建',
    },
    actionUrl: {
      type: [String, Object],
      default: '/resourceTeacherGrowth',
    },
    actionType: {
      type: [String, Number],
      default: undefined,
    },
    sortDictCode: {
      type: String,
      default: '',
    },
    isShowSort: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      collapseList: [
        // {
        //   header: '学校心理健康工作手册',
        //   key: '1',
        //   children: [
        //     {
        //       header: '手册使用说明',
        //       key: '七年级1班',
        //     },
        //   ],
        // },
      ],
      activeKey: [],
      activePaneObj: {},
      pageNo: 1,
      pageSize: 10,
      total: 0,
    }
  },
  watch: {
    actionType: {
      handler(val) {
        this.getOpenKeys()
        this.getTeacherGrowthList()
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    currActionUrl() {
      return this.actionUrl?.[0] === '/' ? this.actionUrl : `/${this.actionUrl}`
    },
  },
  methods: {
    async getTeacherGrowthList() {
      const res = await getAction(`${this.currActionUrl}/list`, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        type: this.actionType,
      })
      if (res.success) {
        const treeData = sortFlatToTree(res.result.records, 'classify')
        this.collapseList =
          treeData?.map((item) => ({
            header: item.children[0].classify_dictText || '其他',
            key: item.classify,
            children: item.children.map((child) => ({
              ...child,
              header: child.title,
              key: child.id,
            })),
          })) || []
        if (!this.collapseList.length) return
        this.activeKey = [this.collapseList[0].key]
        this.activePaneObj = this.collapseList[0].children[0]
      }
    },
    getOpenKeys() {
      this.activeKey = this.collapseList.map((item) => item.key)
    },
    selectItem(obj) {
      this.activePaneObj = obj
    },
    onExpand() {
      console.log('Trigger Expand')
    },
    createLeague() {
      this.$refs.createSubjectModalRef.showModal()
    },
    editItem(obj) {
      console.log('编辑：', obj)
      this.$refs.createSubjectModalRef.showModal(obj)
    },
  },
}
</script>
<style scoped lang="less">
.collapse {
  /deep/ .ant-collapse {
    border: 1px solid #eef7ff;
  }
  .collapse-item {
    padding: 10px;
    margin: 4px;
    cursor: pointer;
    &:hover {
      //color: #fff;
      background-color: #eaf5ff;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .active {
    background-color: #eaf5ff;
    border-radius: 4px;
  }
}
</style>
